import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Link, useNavigate } from "react-router-dom";
import { mockdataVideoType } from "../type/interface";

import { parseDate, toHoursAndMinutes } from "../utils/dateandtime";

interface VideoCardProps {
  data: mockdataVideoType;
  key: string;
  setVideoURL: Function;
  setIsModalOpen: Function;
  videoModalOpen: Function;
  UrlFunction: Function;
  setIsAuth2nd: Function;
  isAuth2nd: {
    identity: string;
    sls: boolean;
    police: boolean;
    uts: boolean;
  };
}
export default function VideoCard(props: VideoCardProps) {
  const {
    data: {
      date,
      // duration,
      provider,
      postcode,
      // videoURL,
      // locality,
      thumbnail,
      _id,
      name,
    },
    setVideoURL,
    setIsModalOpen,
    UrlFunction,
    videoModalOpen,
    setIsAuth2nd,
    isAuth2nd,
  } = props;
  // React.useEffect(() => {
  //   UrlFunction(videoURL);
  // }, []);
  // const getClassname = (sensitivity: string): string | undefined => {
  //   if (sensitivity === "public") return "badge bg-info";
  //   if (sensitivity === "sharing") return "badge bg-success";
  //   if (sensitivity === "internal") return "badge bg-warning text-dark";
  //   return;
  // };

  // const user = localStorage.getItem("user");
  // const objUser = JSON.parse(user);

  const navigate = useNavigate();
  const eventWork = async (e: any) => {
    console.log("get message333");
    console.log(e);
  };

  function IconHandleClick() {
    // window.open(
    //   get2ndAuthUrl(provider),
    //   "_blank" // <- This is what makes it open in a new window.
    // );
    // // window.location.reload();
    // navigate("/video");
    // window.location.reload();
  }

  return (
    <Card
      sx={{
        width: "300px",
        margin: "10px 10px",
        // backgroundColor: "lightgrey",
        position: "relative",
        ":hover": {
          boxShadow:
            "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
        },
      }}
    >
      <Link
        // to={"/video/" + _id}
        to={`/video/${_id}`}
        target="_blank"
        // onClick={() => {
        //   IconHandleClick();
        // }}
      >
        <CardMedia
          sx={{ height: 140, backgroundColor: "#e0e0e0" }}
          image={thumbnail && thumbnail[0] ? thumbnail[0] : undefined}
          title={name}
          // onClick={() => {
          //   videoModalOpen(true);
          // }}
        />
      </Link>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          // background: "yellow",
          height: "25px",
          marginTop: "-28px",
        }}
      >
        <div
          style={{
            marginLeft: "4px",
            background: "black",
            color: "white",
            minWidth: "35px",
            maxWidth: "40px",
            textAlign: "center",
            borderRadius: "10px",
            padding: "1px 6px",
            lineHeight: "25px",
          }}
        >
          {/* <div>{toHoursAndMinutes(duration)}</div> */}
        </div>
      </div>
      <CardContent
        sx={{
          position: "relative",
          padding: "10px 15px",
          paddingBottom: "0px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            height: "40px",
          }}
        >
          <div
            style={{
              height: "40px",
              borderRadius: "20px",
              textAlign: "center",
              lineHeight: "40px",
              fontSize: "20px",
              fontWeight: "500",
            }}
          >
            {name.toUpperCase()}
          </div>

          <div
            style={{ fontSize: "16px", padding: "8px" }}
            // className={getClassname(sensitivity)}
          >
            {/* {sensitivity} */}
          </div>
        </div>
        <p style={{ margin: "8px 0px 0px 0px", fontSize: "15px" }}>
          <span style={{ fontSize: "18px" }}>
            <strong>{provider.toUpperCase()}</strong>
          </span>
        </p>

        <p style={{ marginBottom: "0px", fontSize: "15px" }}>
          <span>{date && parseDate(date)}</span>
        </p>
        <p style={{ marginBottom: "0px", fontSize: "15px" }}>
          {/* <span>{locality}</span> */}
          <span> • </span>
          <span>{postcode}</span>
        </p>
      </CardContent>
    </Card>
  );
}
